/**
 * Catálogo dos tutoriais em vídeo publicados no YouTube.
 *
 * Para adicionar um novo tutorial: inclua uma entrada aqui e use
 * `<HelpVideoButton videoKey="suaChave" />` no cabeçalho da tela correspondente.
 * Quando a mesma tela tiver mais de um tutorial, passe um array:
 * `<HelpVideoButton videoKey={["chaveA", "chaveB"]} />` — o modal abre com a lista.
 *
 * Os vídeos ficam como "Não listado" no YouTube (privado não permite incorporação)
 * e precisam estar com a opção de incorporação habilitada.
 */
export const TUTORIAL_VIDEOS = {
    hoursApproval: {
        youtubeId: "lbEoa5TwxHU",
        title: "Como aprovar as horas do seu time",
    },
    employeeProjectHours: {
        youtubeId: "EpKxV6YLGxU",
        title: "Como apontar suas horas e acompanhar o saldo do mês",
    },
    employeeSignUp: {
        youtubeId: "n5rVUlfiIx4",
        title: "Como fazer seu cadastro no OneWork pelo link de convite",
    },
    companyPaymentSchedule: {
        youtubeId: "jn8NU8DDt54",
        title: "Como funciona o cronograma de pagamento — competência, prazos e valor",
    },
    companyFixedValueBelow: {
        youtubeId: "yPCDFHZXE1Y",
        title: "Por que o valor do mês está menor que o fixo combinado",
    },
    employeePaymentSchedule: {
        youtubeId: "r-u_ysf1Oko",
        title: "Como acompanhar seus pagamentos e entender o valor do mês",
    },
    employeeBank: {
        youtubeId: "QvopPzKT6M4",
        title: "Como cadastrar seus dados bancários e a chave Pix",
    },
};

export default TUTORIAL_VIDEOS;
